/* eslint 'jsx-a11y/anchor-is-valid': 'off', eqeqeq: 'off'  */ /* eslint react/no-direct-mutation-state: "off",'no-redeclare': 'off', eqeqeq: 'off', no-useless-escape: 'off', no-useless-concat: 'off', no-unused-vars: 'off' */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { Label, Button, Modal, Table } from 'reactstrap';
import { GetCampusMonthlyCharges, GetCalculationDiagram } from '../../../action/ASU/BillingInvoicesAction';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { FaRegCalendarAlt } from 'react-icons/fa';
import '../../../Assets/EnsembleStyles/BillingInvoices.css';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Conversions from '../../../Resources/Conversions';
//import { FaPrint } from 'react-icons/fa';
import ASULogo from '../../../Assets/images/ASU-logo-horizontal_02.png';

const month = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const PlantFilters = ['Central Plant', 'CHP', 'Campus'];
var g_SelectedCampus = "1",dateformat = "";
let sortvalue;
class ASUMonthlyCharges extends Component {

    componentWillMount() {
        sortvalue = true;
        var FilterDetails = sessionStorage.getItem('ASUMonthlyTabFilter');
        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);
            this.props.GetCampusMonthlyCharges(lFilterDetails.MonthlyFilterYear, lFilterDetails.Monthlyfiltervalue);
            var FilterDt = new Date();
            FilterDt.setDate(1);
            FilterDt.setMonth(1);
            FilterDt.setFullYear(lFilterDetails.MonthlyFilterYear);
            this.setState({ FilterDate: FilterDt, selectedCampus: lFilterDetails.Monthlyfiltervalue });
        }else{
            this.props.GetCampusMonthlyCharges(new Date().getFullYear(), 1);
        }
        this.props.GetCalculationDiagram();
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedCampus: "1",
            sort: {
                column: null,
                direction: 'desc',
            },
            defaultSort: true,
            calculationmodal: false,
            FilterDate: new Date(),
            sortprint:false
        }
        this.handleCampusChange = this.handleCampusChange.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
        this.OpenHideCalculationPopup = this.OpenHideCalculationPopup.bind(this);
        this.setFilterDate = this.setFilterDate.bind(this);
        this.onFilterCalendarOpen = this.onFilterCalendarOpen.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
        this.printpreview = this.printpreview.bind(this);
    }

    MonthComparator(Month1, Month2) { 
        sortvalue = !sortvalue; 
        let nameA, nameB, yearA, yearB;
        nameA = month.indexOf(Month1.split(" ")[0]);
        nameB = month.indexOf(Month2.split(" ")[0]);
        yearA = parseInt(Month1.split(" ")[1]);
        yearB = parseInt(Month2.split(" ")[1]);

        if(yearA !== yearB)
            return (yearA - yearB);
        else
            return (nameA - nameB);
    }

    NumberComparator(Number1, Number2) { 
        Number1 = Number1.replace('$',"");
        Number2 = Number2.replace('$',"");

        let PreferedDateFormat = dateformat;
        var n1 = Conversions.getInvariantNumber(PreferedDateFormat, Number1);
        var n2 = Conversions.getInvariantNumber(PreferedDateFormat, Number2);      

        return (n1 - n2);
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onExportInvoice(){
        //this.gridApi.paginationGoToLastPage();
        const params = {
            columnGroups: true,
            allColumns: true,
            fileName: 'Monthly_Charges_List',
            columnSeparator:''
            
          };
          this.gridApi.exportDataAsCsv(params);
    }


    setFilterDate(date) {
        this.setState({ FilterDate: date });
    }

    onFilterCalendarOpen() {
        var aa = document.getElementsByClassName('react-datepicker__tab-loop');
        aa[0].id = "asu_wrapper_calendar";
    }

    OpenHideCalculationPopup() {
        this.setState({ calculationmodal: !this.state.calculationmodal });
    }

    handleCampusChange() {
        var selectedOption = this.refs.campus_in_Select_input.options.selectedIndex;
        var selectedId = this.refs.campus_in_Select_input.options[selectedOption].id;
        g_SelectedCampus = selectedId;
        //this.setState({ selectedCampus: selectedId });
    }


    onSort = (column) => e => {
        this.setState({ defaultSort: false });
        const direction = (column !== null) ? (this.state.sort.direction === 'desc') ? 'asc' : 'desc' : 'desc';
        if (this.props.campusMonthlyCharges !== null && this.props.campusMonthlyCharges !== undefined) {
            var SortData = this.state.selectedCampus === "1" ? this.props.campusMonthlyCharges.campus_Billing_Invoice : this.state.selectedCampus === "2" ? this.props.campusMonthlyCharges.central_Plant_Invoice : this.props.campusMonthlyCharges.chp_Billing_Invoice;
            if (SortData !== undefined && SortData !== null && SortData.length) {
                const sortedData = SortData.sort((a, b) => {
                    let nameA, nameB;
                    nameA = a[column];
                    nameB = b[column];
                    return (nameA - nameB);
                });
                if (direction === 'desc') {
                    sortedData.reverse();
                }
                if (this.state.selectedCampus === "1")
                    this.props.campusMonthlyCharges.campus_Billing_Invoice = sortedData;
                else if (this.state.selectedCampus === "2")
                    this.props.campusMonthlyCharges.central_Plant_Invoice = sortedData;
                else if (this.state.selectedCampus === "3")
                    this.props.campusMonthlyCharges.chp_Billing_Invoice = sortedData;
            }
        }
        this.setState({
            sort: {
                column: column,
                direction: direction
            }
        });
    }

    OnFilterChange() {
        sortvalue = false;
        var Direction = { column: null, direction: 'desc' }
        this.setState({ selectedCampus: g_SelectedCampus, sort: Direction, defaultSort: true });
        this.props.GetCampusMonthlyCharges(this.state.FilterDate.getFullYear(), g_SelectedCampus);
        var Data = ({ 'Monthlyfiltervalue': g_SelectedCampus, 'MonthlyFilterYear': this.state.FilterDate.getFullYear() });
        sessionStorage.setItem('ASUMonthlyTabFilter', JSON.stringify(Data));
        
    }

    printpreview()
    {
        var imgURL = document.getElementById('ASU_logo1').src;
        var CurrentDateTime = new Date();
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth() + 1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var WindowHeight = ((window.screen.height) - 200) + 'px';
        var WindowWidth = ((window.screen.width) - 10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height=' + WindowHeight + ', width=' + WindowWidth + ', resizable=1, scrollbars=yes, layout=1');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');
        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class='row row_padding'><div class='col-md-12'>");
        //writeMe += ("<br/><label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float:left;margin-left:16px;'>Monthly Charges</label><label class='workOrderlabel' style='float:right;margin-right:16px;'>" + CurrentDate + "</label><br/>");
        writeMe += ("<div style='margin:5px'><div style='min-height: 25px;'><img style='height: 116px; width:385px ;margin-bottom: -20px;margin-top: -18px; margin-left: -10px;!important' id='ASU_Logo1' src=" + imgURL + "><label class='workOrderlabel' style='float:right;margin-right:16px;'>" + CurrentDate + "</label></div></div>");
        // writeMe += ("<div style='margin:16px'><div style='position: relative;display: -webkit-flex;display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;-webkit-align-items: center;align-items: center;-webkit-justify-content: space-between;justify-content: space-between;padding: .5rem 1rem;background: transparent linear-gradient(270deg, #104095 0%, #2070CF 100%) 0% 0% no-repeat padding-box !important; min-height: 54px;-webkit-flex-flow: row nowrap;flex-flow: row nowrap;-webkit-justify-content: flex-start;justify-content: flex-start;'><img id='Trane_Logo' src=" + imgURL + "></div></div>");
        writeMe += ("<label style='height: 15px;text-align: left;letter-spacing: 0px;color: #4A4A4A;opacity: 1;font-family: lato;font-size: 15px;padding-left: 15px;'>Plant/Campus :  " + this.refs.campus_in_Select_input.selectedOptions[0].innerHTML + "</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;padding-left: 16px; padding-bottom: 3px;'>Year: " + this.state.FilterDate.getFullYear() + "</label>");
        //writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float: right; padding-right: 14px;'>" + PrintPaginationText + "</label>");
        writeMe += ("<div id='divPrintPreview'>" + printContent + "</div>");
        writeMe += ("<br/><br/><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class='print_footer' style='padding-left: 16px; padding-bottom: 3px;'>Tracer Ensemble<br/>© 2021 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='borderTop:1px solid #FFFFFF; padding-bottom: 50px;'/><div style='margin-top:10px; margin-bottom:25px; margin-right:4px'><div style='float:right;'>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #BBBBBB 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 80px;height: 30px;float: right; margin-left: 6px; margin-right:10px; width:106px' id='btnPrint' onclick='javascript:window.close();' >Close Window</button>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #61AE34 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; id='btnPrint' onclick='javascript:window.print();' >Print</button>");
        writeMe += ("</div></div><br/>");
        writeMe += ('</body></html>');
        if(printWindow != null){
          printWindow.document.write(writeMe);
        }
        printWindow.document.close();
        if (window.focus) {
            printWindow.focus();
        }
    }

    OpenPrintPreview() {
      // let printsort = this.state.sortprint; //save the sort for print pop up
        this.setState({sortprint:sortvalue});
        window.setTimeout(this.printpreview,3000);      
    }

    render(UserPreference_response) {
        var data = this.props.campusMonthlyCharges;
        //let label = this.props.getLabels;
        var CalculationDiagram;
        let Campus_Filter = [], StructuredData = [], columnDefs = [];
        let PreferedDateFormat = this.props.UserPreference_response;
        dateformat = PreferedDateFormat;
        let MonthlyChargesTable = [];

        if (data !== null && data !== undefined) {
            //Campus Filter
            if (this.state.selectedCampus === "3") {
                var ItemRows = [];
                columnDefs = [
                    { headerName: "MONTH", field: "billingDate", pinned: 'left', width: 150, sortable: true, sortingOrder: ['asc', 'desc'], comparator: this.MonthComparator, sort: 'asc' },
                    { headerName: "O&M Utilities Rate", tooltip: (params) => params.value, field: "sC_OM_Utilities_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "O&M Capital Rate", tooltip: (params) => params.value, field: "sC_OM_Capital_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "Water Rate",tooltip: (params) => params.value, field: "sC_Water_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "Sewer Cost", tooltip: (params) => params.value, field: "sC_Sewer_Cost", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "Campus CHW&HTG MMBTU", tooltip: (params) => params.value, field: "eiS_Campus_CHW_and_HTG_mmBTU", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "kWh Rate", tooltip: (params) => params.value, field: "billing_Blended_Electric_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHW Rate", tooltip: (params) => params.value, field: "billing_Blended_CHW_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "HTG Rate", tooltip: (params) => params.value, field: "billing_Blended_Heating_Rate", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "Water Cost", tooltip: (params) => params.value, field: "billing_Total_Water_Cost", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                ];
                
             

                if (data.campus_Billing_Invoice !== undefined && data.campus_Billing_Invoice !== null && data.campus_Billing_Invoice.length) {

                        if(this.state.sortprint)
                           data.campus_Billing_Invoice = data.campus_Billing_Invoice.reverse();

                    data.campus_Billing_Invoice.forEach(item => {
                        var lineitem = {
                            "billingDate": item.billingDate,
                            //"billingMonth": month[item.billingMonth],
                            "sC_OM_Utilities_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.sC_OM_Utilities_Rate),
                            "sC_OM_Capital_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.sC_OM_Capital_Rate),
                            "sC_Water_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.sC_Water_Rate),
                            "sC_Sewer_Cost": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.sC_Sewer_Cost),
                            "eiS_Campus_CHW_and_HTG_mmBTU": Conversions.formatNumberASU(PreferedDateFormat, item.eiS_Campus_CHW_and_HTG_mmBTU),
                            "billing_Blended_Electric_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.billing_Blended_Electric_Rate),
                            "billing_Blended_CHW_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.billing_Blended_CHW_Rate),
                            "billing_Blended_Heating_Rate": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.billing_Blended_Heating_Rate),
                            "billing_Total_Water_Cost": "$" + Conversions.formatNumberASU(PreferedDateFormat, item.billing_Total_Water_Cost)
                        }

                        var trItem = <tr>
                            <td>{lineitem.billingDate}</td>
                            <td>{lineitem.sC_OM_Utilities_Rate}</td>
                            <td>{lineitem.sC_OM_Capital_Rate}</td>
                            <td>{lineitem.sC_Water_Rate}</td>
                            <td>{lineitem.sC_Sewer_Cost}</td>
                            <td>{lineitem.eiS_Campus_CHW_and_HTG_mmBTU}</td>
                            <td>{lineitem.billing_Blended_Electric_Rate}</td>
                            <td>{lineitem.billing_Blended_CHW_Rate}</td>
                            <td>{lineitem.billing_Blended_Heating_Rate}</td>
                            <td>{lineitem.billing_Total_Water_Cost}</td>
                        </tr>
                        StructuredData.push(lineitem);
                        ItemRows.push(trItem);
                    });



                }
                else {

                    var trItem = <tr><Table><tr> <td><div style={{ 'text-align': 'center' }} >No Records Found</div></td></tr></Table></tr>
                    ItemRows.push(trItem);

                }

                MonthlyChargesTable = <div className="table_container table_border" id="divPrintWindow" style={{ 'margin-bottom': '0px', 'margin-right': '15px', 'margin-left': '15px' }}>
                    <Table striped responsive className="Custom_table fixed_layout" >
                        <tbody className="cell_container">
                            <tr>
                                <th className="wo_cursor" width="6%" onClick={this.onSort('billingMonth')}>MONTH</th>
                                <th width="6%" className="wo_cursor">O&M Utilities Rate</th>
                                <th width="6%" className="wo_cursor">O&M Capital Rate</th>
                                <th width="6%" className="wo_cursor">Water Rate</th>
                                <th width="6%" className="wo_cursor">Sewer Cost</th>
                                <th width="6%" className="wo_cursor">Campus CHW&HTG MMBTU</th>
                                <th width="6%" className="wo_cursor">kWh Rate</th>
                                <th width="6%" className="wo_cursor">CHW Rate</th>
                                <th width="6%" className="wo_cursor">HTG Rate</th>
                                <th width="6%" className="wo_cursor">Water Cost</th>

                            </tr>
                            {ItemRows}
                        </tbody>
                    </Table>
                </div>
                Campus_Filter = PlantFilters.map((el, index) => (
                    <option id={index + 1} value={index + 1} selected={el === "Campus"} >{el}</option>
                ));
            }
            //Central Plant Filter
            if (this.state.selectedCampus === "1") {
                var ItemRows = [];
                columnDefs = [
                    { headerName: "Month", field: "billingDate", pinned: 'left', width: 150, sortable: true, sortingOrder: ['asc', 'desc'], comparator: this.MonthComparator, sort: 'asc' },
                    { headerName: "CP Total kWh", tooltip: (params) => params.value, field: "cP_Total_Electricity_You_Used", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP kWh Cost", tooltip: (params) => params.value, field: "cP_Total_Charges_For_Electricity_Services", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NS On-Peak kWh", tooltip: (params) => params.value, field: "nS_NET_On_Peak_Electricity_You_Used", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NS Off-Peak kWh", tooltip: (params) => params.value, field: "nS_NET_Off_Peak_Electricity_You_Used", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NS kWh Cost", tooltip: (params) => params.value, field: "nS_Total_Charges_For_Electricity_Services", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP Gas", tooltip: (params) => params.value, field: "cP_GAS_Monthly_Usage", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP Gas Cost", tooltip: (params) => params.value, field: "cP_GAS_Total_Amount_Due", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP Building kWh", tooltip: (params) => params.value, field: "eiS_CP_Bldg_Electrical_Use", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP CHW to Campus", tooltip: (params) => params.value, field: "eiS_CP_CHW_To_Campus_Total", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NCP Building kWh", tooltip: (params) => params.value, field: "eiS_North_CP_Bldg_Electrical_Use", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NCP CHW to Campus", tooltip: (params) => params.value, field: "eiS_North_CP_CHW_To_Campus_Total", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CP Water Make-up", tooltip: (params) => params.value, field: "cP_Water_Make_Up", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "NCP Water Make-up", tooltip: (params) => params.value, field: "ncP_Water_Make_Up", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                ];
                if (data.central_Plant_Invoice !== undefined && data.central_Plant_Invoice !== null && data.central_Plant_Invoice.length) {
                    
                    if(this.state.sortprint)
                        data.central_Plant_Invoice = data.central_Plant_Invoice.reverse();

                    data.central_Plant_Invoice.forEach(item => {
                        var lineitem = {
                            "billingDate": item.billingDate,
                            //"billingMonth": month[item.billingMonth],
                            "cP_Total_Electricity_You_Used": Conversions.formatNumber(PreferedDateFormat, item.cP_Total_Electricity_You_Used),
                            "cP_Total_Charges_For_Electricity_Services": "$" + Conversions.formatNumber(PreferedDateFormat, item.cP_Total_Charges_For_Electricity_Services),
                            "nS_NET_On_Peak_Electricity_You_Used": Conversions.formatNumber(PreferedDateFormat, item.nS_NET_On_Peak_Electricity_You_Used),
                            "nS_NET_Off_Peak_Electricity_You_Used": Conversions.formatNumber(PreferedDateFormat, item.nS_NET_Off_Peak_Electricity_You_Used),
                            "nS_Total_Charges_For_Electricity_Services": "$" + Conversions.formatNumber(PreferedDateFormat, item.nS_Total_Charges_For_Electricity_Services),
                            "cP_GAS_Monthly_Usage": Conversions.formatNumber(PreferedDateFormat, item.cP_GAS_Monthly_Usage),
                            "cP_GAS_Total_Amount_Due": "$" + Conversions.formatNumber(PreferedDateFormat, item.cP_GAS_Total_Amount_Due),
                            "eiS_CP_Bldg_Electrical_Use": Conversions.formatNumber(PreferedDateFormat, item.eiS_CP_Bldg_Electrical_Use),
                            "eiS_CP_CHW_To_Campus_Total": Conversions.formatNumber(PreferedDateFormat, item.eiS_CP_CHW_To_Campus_Total),
                            "eiS_North_CP_Bldg_Electrical_Use": Conversions.formatNumber(PreferedDateFormat, item.eiS_North_CP_Bldg_Electrical_Use),
                            "eiS_North_CP_CHW_To_Campus_Total": Conversions.formatNumber(PreferedDateFormat, item.eiS_North_CP_CHW_To_Campus_Total),
                            "cP_Water_Make_Up": Conversions.formatNumber(PreferedDateFormat, item.cP_Water_Make_Up),
                            "ncP_Water_Make_Up": Conversions.formatNumber(PreferedDateFormat, item.ncP_Water_Make_Up)
                        }

                        var trItem = <tr>
                            <td>{lineitem.billingDate}</td>
                            <td>{lineitem.cP_Total_Electricity_You_Used}</td>
                            <td>{lineitem.cP_Total_Charges_For_Electricity_Services}</td>
                            <td>{lineitem.nS_NET_On_Peak_Electricity_You_Used}</td>
                            <td>{lineitem.nS_NET_Off_Peak_Electricity_You_Used}</td>
                            <td>{lineitem.nS_Total_Charges_For_Electricity_Services}</td>
                            <td>{lineitem.cP_GAS_Monthly_Usage}</td>
                            <td>{lineitem.cP_GAS_Total_Amount_Due}</td>
                            <td>{lineitem.eiS_CP_Bldg_Electrical_Use}</td>
                            <td>{lineitem.eiS_CP_CHW_To_Campus_Total}</td>
                            <td>{lineitem.eiS_North_CP_Bldg_Electrical_Use}</td>
                            <td>{lineitem.eiS_North_CP_CHW_To_Campus_Total}</td>
                            <td>{lineitem.cP_Water_Make_Up}</td>
                            <td>{lineitem.ncP_Water_Make_Up}</td>
                        </tr>

                        StructuredData.push(lineitem);
                        ItemRows.push(trItem);
                    });

                }
                else {

                    var trItem = <tr><Table><tr> <td><div style={{ 'text-align': 'center' }} >No Records Found</div></td></tr></Table></tr>
                    ItemRows.push(trItem);

                }
                MonthlyChargesTable = <div className="table_container table_border" id="divPrintWindow" style={{ 'margin-bottom': '0px', 'margin-right': '15px', 'margin-left': '15px' }}>
                    <Table striped responsive className="Custom_table fixed_layout" >
                        <tbody className="cell_container">
                            <tr>
                                <th className="wo_cursor" width="6%" onClick={this.onSort('billingMonth')}>MONTH</th>
                                <th width="6%" className="wo_cursor">CP Total kWh</th>
                                <th width="6%" className="wo_cursor">CP kWh Cost</th>
                                <th width="6%" className="wo_cursor">NS On-Peak kWh</th>
                                <th width="6%" className="wo_cursor">NS Off-Peak kWh</th>
                                <th width="6%" className="wo_cursor">NS kWh Cost</th>
                                <th width="6%" className="wo_cursor">CP Gas</th>
                                <th width="6%" className="wo_cursor">CP Gas Cost</th>
                                <th width="6%" className="wo_cursor">CP Building kWh</th>
                                <th width="6%" className="wo_cursor">CP CHW to Campus</th>
                                <th width="6%" className="wo_cursor">NCP Building kWh</th>
                                <th width="6%" className="wo_cursor">NCP CHW to Campus</th>
                                <th width="6%" className="wo_cursor">CP Water Make-up</th>
                                <th width="6%" className="wo_cursor">NCP Water Make-up</th>

                            </tr>
                            {ItemRows}
                        </tbody>
                    </Table>
                </div>




                Campus_Filter = PlantFilters.map((el, index) => (
                    <option id={index + 1} value={index + 1} selected={el === "Central Plant"} >{el}</option>
                ));

            }
            //CHP Filter
            if (this.state.selectedCampus === "2") {
                var ItemRows = [];
                columnDefs = [
                    { headerName: "MONTH", field: "billingDate", pinned: 'left', sortingOrder: ['asc', 'desc'], comparator: this.MonthComparator, sort: 'asc' },
                    { headerName: "CHP kWh", tooltip: (params) => params.value, field: "chP_Total_Electricity_You_Used_In_kWh", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP kWh Cost", tooltip: (params) => params.value, field: "chP_Total_Charges_For_Electricity_Services", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gen kWh", tooltip: (params) => params.value, field: "chP_ASU_Generator_Meter_Total_kWh", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas", tooltip: (params) => params.value, field: "chP_GAS_Monthly_Usage", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas Cost", tooltip: (params) => params.value, field: "chP_GAS_Total_Amount_Due", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Steam to Campus", tooltip: (params) => params.value, field: "eiS_CHP_Steam_To_Campus", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Building kWh", tooltip: (params) => params.value, field: "eiS_CHP_Bldg_Electrical_Use", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP CHW to Campus", tooltip: (params) => params.value, field: "eiS_CHP_CHW_To_Campus_Total", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Water Make-up", tooltip: (params) => params.value, field: "chP_Water_Make_Up", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas kWh %", tooltip: (params) => params.value, field: "billing_CHP_Gas_Electric_Gen_Pct", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas kWh Cost", tooltip: (params) => params.value, field: "billing_CHP_Gas_Cost_Electric_Gen", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP kWh Total", tooltip: (params) => params.value, field: "billing_CHP_Total_Electric_Delivered", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas Steam %", tooltip: (params) => params.value, field: "billing_CHP_Gas_Steam_Prod_Pct", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator },
                    { headerName: "CHP Gas Steam Cost", tooltip: (params) => params.value, field: "billing_CHP_Gas_Cost_Steam_Prod", cellClass: 'ag-cell-alignment', headerClass: 'ag-header-alignmnet',sortingOrder: ['asc', 'desc'],comparator: this.NumberComparator }
                ];
                if (data.chp_Billing_Invoice !== undefined && data.chp_Billing_Invoice !== null && data.chp_Billing_Invoice.length) {

                    if(this.state.sortprint)
                        data.chp_Billing_Invoice = data.chp_Billing_Invoice.reverse();

                    data.chp_Billing_Invoice.forEach(item => {
                        var lineitem = {
                            "billingDate": item.billingDate,
                            //"billingMonth": month[item.billingMonth],
                            "chP_Total_Electricity_You_Used_In_kWh": Conversions.formatNumber(PreferedDateFormat, item.chP_Total_Electricity_You_Used_In_kWh),
                            "chP_Total_Charges_For_Electricity_Services": "$" + Conversions.formatNumber(PreferedDateFormat, item.chP_Total_Charges_For_Electricity_Services),
                            "chP_ASU_Generator_Meter_Total_kWh": Conversions.formatNumber(PreferedDateFormat, item.chP_ASU_Generator_Meter_Total_kWh),
                            "chP_GAS_Monthly_Usage": Conversions.formatNumber(PreferedDateFormat, item.chP_GAS_Monthly_Usage),
                            "chP_GAS_Total_Amount_Due": "$" + Conversions.formatNumber(PreferedDateFormat, item.chP_GAS_Total_Amount_Due),
                            "eiS_CHP_Steam_To_Campus": Conversions.formatNumber(PreferedDateFormat, item.eiS_CHP_Steam_To_Campus),
                            "eiS_CHP_Bldg_Electrical_Use": Conversions.formatNumber(PreferedDateFormat, item.eiS_CHP_Bldg_Electrical_Use),
                            "eiS_CHP_CHW_To_Campus_Total": Conversions.formatNumber(PreferedDateFormat, item.eiS_CHP_CHW_To_Campus_Total),
                            "chP_Water_Make_Up": Conversions.formatNumber(PreferedDateFormat, item.chP_Water_Make_Up),
                            "billing_CHP_Gas_Electric_Gen_Pct": Conversions.formatNumber(PreferedDateFormat, item.billing_CHP_Gas_Electric_Gen_Pct),
                            "billing_CHP_Gas_Cost_Electric_Gen": "$" + Conversions.formatNumber(PreferedDateFormat, item.billing_CHP_Gas_Cost_Electric_Gen),
                            "billing_CHP_Total_Electric_Delivered": Conversions.formatNumber(PreferedDateFormat, item.billing_CHP_Total_Electric_Delivered),
                            "billing_CHP_Gas_Steam_Prod_Pct": Conversions.formatNumber(PreferedDateFormat, item.billing_CHP_Gas_Steam_Prod_Pct),
                            "billing_CHP_Gas_Cost_Steam_Prod": "$" + Conversions.formatNumber(PreferedDateFormat, item.billing_CHP_Gas_Cost_Steam_Prod)
                        }

                        var trItem = <tr>
                            <td>{lineitem.billingDate}</td>
                            <td>{lineitem.chP_Total_Electricity_You_Used_In_kWh}</td>
                            <td>{lineitem.chP_Total_Charges_For_Electricity_Services}</td>
                            <td>{lineitem.chP_ASU_Generator_Meter_Total_kWh}</td>
                            <td>{lineitem.chP_GAS_Monthly_Usage}</td>
                            <td>{lineitem.chP_GAS_Total_Amount_Due}</td>
                            <td>{lineitem.eiS_CHP_Steam_To_Campus}</td>
                            <td>{lineitem.eiS_CHP_Bldg_Electrical_Use}</td>
                            <td>{lineitem.eiS_CHP_CHW_To_Campus_Total}</td>
                            <td>{lineitem.chP_Water_Make_Up}</td>
                            <td>{lineitem.billing_CHP_Gas_Electric_Gen_Pct}</td>
                            <td>{lineitem.billing_CHP_Gas_Cost_Electric_Gen}</td>
                            <td>{lineitem.billing_CHP_Total_Electric_Delivered}</td>
                            <td>{lineitem.billing_CHP_Gas_Steam_Prod_Pct}</td>
                            <td>{lineitem.billing_CHP_Gas_Cost_Steam_Prod}</td>
                        </tr>

                        StructuredData.push(lineitem);
                        ItemRows.push(trItem);
                    });

                }
                else {

                    var trItem = <tr><Table><tr> <td><div style={{ 'text-align': 'center' }} >No Records Found</div></td></tr></Table></tr>
                    ItemRows.push(trItem);
                }
                MonthlyChargesTable = <div className="table_container table_border" id="divPrintWindow" style={{ 'margin-bottom': '0px', 'margin-right': '15px', 'margin-left': '15px' }}>
                    <Table striped responsive className="Custom_table fixed_layout" >
                        <tbody className="cell_container">
                            <tr>
                                <th className="wo_cursor" width="6%" onClick={this.onSort('billingMonth')}>MONTH</th>
                                <th width="6%" className="wo_cursor">CHP kWh</th>
                                <th width="6%" className="wo_cursor">CHP kWh Cost</th>
                                <th width="6%" className="wo_cursor">CHP Gen kWh</th>
                                <th width="6%" className="wo_cursor">CHP Gas</th>
                                <th width="6%" className="wo_cursor">CHP Gas Cost</th>
                                <th width="6%" className="wo_cursor">CHP Steam to Campus</th>
                                <th width="6%" className="wo_cursor">CHP Building kWh</th>
                                <th width="6%" className="wo_cursor">CHP CHW to Campus</th>
                                <th width="6%" className="wo_cursor">CHP Water Make-up</th>
                                <th width="6%" className="wo_cursor">CHP Gas kWh %</th>

                                <th width="6%" className="wo_cursor">CHP Gas kWh Cost</th>
                                <th width="6%" className="wo_cursor">CHP kWh Total</th>
                                <th width="6%" className="wo_cursor">CHP Gas Steam %</th>
                                <th width="6%" className="wo_cursor">CHP Gas Steam Cost</th>

                            </tr>
                            {ItemRows}
                        </tbody>
                    </Table>
                </div>

                Campus_Filter = PlantFilters.map((el, index) => (
                    <option id={index + 1} value={index + 1} selected={el === "CHP"} >{el}</option>
                ));
            }
        }

        if (this.props.BillingCalculations !== undefined && this.props.BillingCalculations !== null && this.props.BillingCalculations.length) {
            CalculationDiagram = this.props.BillingCalculations.map(item => (
                <div>
                    <label className="lbl_diagram_sub_header">{item.dataPointText}</label><br />
                    <label className="lbl_diagram_text">{item.calculationText}</label><br />
                </div>
            ));
        }

        return (
            <div className="main_container">
                <div className="border_container">
                    <div className="main_container">
                        <div className="row row_padding">
                            <div className="col-md-12">
                                <Label className="ASUHeaderLabel">Monthly Charges</Label>
                                <div class="ASUdropdown" style={{float:'right', marginLeft:'8px'}}>
                                    <button type="button" class="ASUdropbtn" ><span className="ASUdropdowntxt">PRINT SCREEN</span><i className="arrowi down" style={{float:'right'}}></i></button>
                                    <div class="ASUdropdown-content">
                                        <a onClick={this.OpenPrintPreview}>Print...</a>
                                        <a onClick={() => {this.onExportInvoice()}}>Export as Excel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row row_padding">
                            <div className="col-md-7">
                                <label style={{ "margin-right": "10px" }} className="lbl_asu_filter_text">Fiscal Year:</label>
                                <label style={{ 'cursor': 'pointer' }}>
                                    <div className="pm_calendardiv" style={{ "margin-top": "0px" }}>
                                        <FaRegCalendarAlt className="pm_calendarbox" />
                                    </div>
                                    <DatePicker selected={this.state.FilterDate} onChange={date => this.setFilterDate(date)}
                                        id="FilterCalendar"
                                        onCalendarOpen={this.onFilterCalendarOpen}
                                        dateFormat={"yyyy"}
                                        showYearPicker={true} />

                                </label>
                                <Label className="ASUTextLabel" style={{ marginLeft: "20px" }}>Plant/Campus:</Label>
                                <select ref='campus_in_Select_input' style={{ "margin-left": "10px", "margin-top": "10px" }} className="pmminimal pm-dropdown" onChange={this.handleCampusChange}>
                                    {Campus_Filter}
                                </select>
                                <Button style={{ "margin-left": "15px" }} className="asu-applybutton" onClick={() => { this.OnFilterChange() }}>{"APPLY"}</Button>

                            </div>
                            
                            <div style={{ paddingTop: '15px', width: '40.5%' }}>
                                <p className="link_cursor ASUTextUnderline" onClick={this.OpenHideCalculationPopup} style={{ float: "right" }}>View Calculations Diagram </p>
                            </div>
                            
                        </div>
                        <br />
                        <div className="ASU table_container table_border" style={{ 'margin-bottom': '0px' }}>
                            {/* <Table striped responsive className="Custom_table">
                                <tbody className="cell_container">
                                    {monthlyChargeHeaders}
                                    {monthlyCharges}
                                </tbody>
                            </Table> */}
                            <div className="ag-theme-alpine" id="divMonthlyChargePrintWindow" style={{ 'width': '100%' }} domLayout='autoHeight'>
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={StructuredData}
                                    domLayout='autoHeight'
                                    overlayNoRowsTemplate='No Records Found'
                                    overlayLoadingTemplate='Loading...'
                                    suppressCellSelection={true}
                                    suppressMovableColumns={true}
                                    onGridReady={this.onGridReady.bind(this)}
                                    enableSorting={true} 
                                    
                                   

                                >
                                </AgGridReact>
                            </div>
                        </div>
                        <Modal isOpen={this.state.calculationmodal} contentClassName="resetContainer" >
                            <div>
                                <p className='lbl_diagram_main_header' style={{ 'padding-top': '10px', 'padding-left': '10px' }}>Calculations Diagram
                                <span className="wo_employee_closeIcon" onClick={this.OpenHideCalculationPopup}>X</span>
                                </p>
                                <div style={{ borderTop: '1px solid #FFFFFF', 'padding-bottom': '10px' }} />
                                <div className="passwordContainer" style={{ 'max-height': '400px', 'overflow-y': 'auto', 'margin': '15px' }}>
                                    {CalculationDiagram}
                                </div>
                                <div style={{ borderTop: '1px solid #FFFFFF', 'margin-top': '20px', 'margin-bottom': '12px' }} />
                                <div style={{ marginTop: '10px', marginBottom: '48px' }}>
                                    <div style={{ float: 'right' }}>
                                        <Button className="wo_save_btn" style={{ 'float': 'right', 'margin-right': '16px' }} onClick={this.OpenHideCalculationPopup} >CLOSE</Button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <div style={{ "display": "none" }}>
                            {MonthlyChargesTable}
                        </div>
                        <div>
                            <img id="ASU_logo1" alt="Trane" src={ASULogo} style={{ "display": "none" }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        campusMonthlyCharges: state.ASUBillingInvoicesRootReducer.CampusMonthlyCharges,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        BillingCalculations: state.ASUBillingInvoicesRootReducer.BillingCalculations,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetCampusMonthlyCharges: (Year, Campus) => dispatch(GetCampusMonthlyCharges(Year, Campus)),
        GetCalculationDiagram: () => dispatch(GetCalculationDiagram())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ASUMonthlyCharges);